import ApiList from "../utils/api_list";
import Coursera from "../utils/courseraAxiosConfig";

const profile = ApiList.profile;
const preSigned = ApiList.preSigned;

// data = { start: 0, limit: 10 }
export const getCourseContents = async (data) => {
  console.log(data, " = dataaaaaaaaaaaaaaaaaaaaaaaaaa");
  data.domains = encodeURIComponent(data.domains)
  data.subDomains = encodeURIComponent(data.subDomains)
  const params = new URLSearchParams();
  params.append("start", data.start || 0);
  params.append("name", data.name || "");
  params.append("limit", data.limit || 20);
  params.append("difficultyLevel", data.difficultyLevel || "");
  params.append("type", data.type || "");
  params.append("skills", data.skills || "");
  params.append("domains", data.domains || "");
  params.append("subDomains", data.subDomains || "");
  console.log(params, "paramssssssss");
  const result = await Coursera.get(`/contents`, { params });
  return result;
};
export const getCourseContentsDetails = async (data) => {
  const result = await Coursera.get(`/contents/Course~${data}`);
  return result;
};
export const getCourseProgress = async () => {
  const result = await Coursera.get(`/enrollment`);
  return result;
};
export const getCourseModuleDetailsData = async (data) => {
  const result = await Coursera.get(`/course/${data}`);
  return result;
};
export const getFilterationData = async () => {
  const result = await Coursera.get(`/coursera-filteration-details`);
  return result;
};


